import React from "react";
import { useIntl } from "react-intl";
import { AccommodationType } from "@shared/models/article";
import { genericTermTranslations } from "../../../../i18n/sharable-defs";
import "./selectors.scss";

type Props = {
  value?: AccommodationType
  onChange?: (value?: AccommodationType) => void
}

const SearchItemSelectorDisplayType = (
  {
    value,
    onChange = () => void 0
  }: Props) => {

  const intl = useIntl();
  return (
    <>

      <label htmlFor={AccommodationType.RENTAL.toLowerCase()}>
        <input type="radio"
               id={AccommodationType.RENTAL.toLowerCase()}
               value={AccommodationType.RENTAL}
               checked={value === AccommodationType.RENTAL}
               onChange={() => onChange(AccommodationType.RENTAL)} />
        {intl.formatMessage(genericTermTranslations.locationHolidays)}
      </label>

      <label htmlFor={AccommodationType.SEASONAL.toLowerCase()}>
        <input type="radio"
               id={AccommodationType.SEASONAL.toLowerCase()}
               value={AccommodationType.SEASONAL}
               checked={value === AccommodationType.SEASONAL}
               onChange={() => onChange(AccommodationType.SEASONAL)} />
        {intl.formatMessage(genericTermTranslations.locationSeasonal)}
      </label>

      <label htmlFor={AccommodationType.ANNUAL.toLowerCase()}>
        <input type="radio"
               id={AccommodationType.ANNUAL.toLowerCase()}
               value={AccommodationType.ANNUAL}
               checked={value === AccommodationType.ANNUAL}
               onChange={() => onChange(AccommodationType.ANNUAL)} />
        {intl.formatMessage(genericTermTranslations.locationYearly)}
      </label>

    </>);

}

export default SearchItemSelectorDisplayType;
